import { render, staticRenderFns } from "./TermsConditionButton.vue?vue&type=template&id=1fd4c3f5"
import script from "./TermsConditionButton.vue?vue&type=script&lang=js"
export * from "./TermsConditionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports